import { enableSocket, localhostURL } from './constants'
import { io } from 'socket.io-client'

let HOST = `http://${localhostURL}:3000/`
export const socket = enableSocket ? io(HOST + 'participant') : null

export const currentVersion = '2022.03.30-a' // !

if (enableSocket) {
  console.log(`Trying to connect to socket ${localhostURL}:3000 ...`)
  socket.on('connect', function () {
    console.log('Connected!', socket.id)
    socket.emit('version', currentVersion)
  })
}
